<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-logindevice`]" width="1em" height="1em" v-bind="$attrs"><defs><linearGradient x1="59.971%" y1="13.612%" x2="29.513%" y2="83.088%" id="svg_27331f8ffc__a"><stop stop-color="#1BA8AF" stop-opacity=".59" offset="0%"/><stop stop-color="#FFF" stop-opacity=".394" offset="100%"/></linearGradient></defs><g fill="none" fill-rule="nonzero"><path d="M119,90.7826087 L119,18 L14,18 L14,90.7826087 L54.3846154,90.7826087 L54.3846154,102.913043 L46.3076923,102.913043 L46.3076923,111 L86.6923077,111 L86.6923077,102.913043 L78.6153846,102.913043 L78.6153846,90.7826087 L119,90.7826087 Z M111,26 L111,67 L22,67 L22,26 L111,26 Z M22,83 L22,75 L111,75 L111,83 L22,83 Z M71,103 L63,103 L63,91 L71,91 L71,103 Z" :fill="useCurrentColor ? 'currentColor' : 'url(#svg_27331f8ffc__a)'"/><path d="M115,93.7826087 L115,21 L10,21 L10,93.7826087 L50.3846154,93.7826087 L50.3846154,105.913043 L42.3076923,105.913043 L42.3076923,114 L82.6923077,114 L82.6923077,105.913043 L74.6153846,105.913043 L74.6153846,93.7826087 L115,93.7826087 Z M107,29 L107,70 L18,70 L18,29 L107,29 Z M18,86 L18,78 L107,78 L107,86 L18,86 Z M66,106 L58,106 L58,94 L66,94 L66,106 Z" :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmLogindevice',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
